<template>
  <div>
    <header>
      <div class="left">
        <p @click="goTo('/events')">Events</p>
        <p @click="goTo('/orders')">Orders</p>
        <!-- <p @click="goTo(`event/${$route.params.id}/reports`)">Reports</p> -->
      </div>

      <img class="logo" src="@/assets/img/logo.svg" />

      <div class="right">
        <button
          @click="() => this.signOut()"
          class="btn text_btn"
          :style="{marginRight: '20px'}"
        >Log Out</button>
        <p @click="goTo('/help')">Help</p>
        <img @click="goTo('/profile')" class="profile" src="@/assets/img/profile.svg" />
        <img @click="mobileMenu = !mobileMenu" class="hamburger" src="@/assets/img/hamburger.svg" />
      </div>

      <transition name="fade">
        <div v-if="mobileMenu" class="mobile_nav">
          <div @click="mobileMenu = false" class="offclick"></div>
          <transition name="slide">
            <div class="menu_slide" v-if="mobileMenu">
              <p>Events</p>
              <p @click="goTo('/orders')">Orders</p>
              <p>Reports</p>
              <p>Help</p>
              <p @click="goTo('/events')">Profile</p>
            </div>
          </transition>
        </div>
      </transition>
    </header>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "heading",
  components: {},
  data() {
    return {
      swipe: false,
      mobileMenu: false
    };
  },
  mounted() {},
  created() {},
  firestore() {
    return {};
  },
  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          window.location.reload();
        })
        .catch(() => {});
    }
  },
  watch: {}
};
</script>

<style lang="scss">
header {
  position: fixed;
  width: 100%;
  background: #0d0d0d;
  z-index: 6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 50px;

  @media screen and (max-width: 800px) {
    justify-content: flex-end;
  }

  @media screen and (max-width: 700px) {
  }

  & > div {
    display: flex;
    align-items: center;
  }

  p {
    color: white;
    margin: 0;
    margin-right: 30px;
    font-size: 17px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #fba500;
    }
  }
  .logo {
    width: 100px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    @media screen and (max-width: 700px) {
      left: 30px;
      transform: none;
    }
  }

  img {
    cursor: pointer;
  }

  .mobile_nav {
    position: absolute;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 6;
    min-height: 100vh;
    top: 50px;

    .menu_slide {
      position: absolute;
      z-index: 2;
      background: #333333;
      display: flex;
      flex-direction: column;
      width: 250px;
      height: 100%;
      right: 0;
      top: 30px;

      p {
        color: white;
        font-size: 18px;
        padding: 15px 20px;
        background: #333333;
        border-bottom: 2px solid #0d0d0d;
        width: 100%;

        &:hover {
          color: #fba500;
        }
      }
    }

    .offclick {
      position: absolute;
      top: 30px;
      z-index: 1;
      height: 100%;
      width: 100%;
      background: rgba(0, 0, 0, 0.62);
    }
  }

  .left,
  .right p {
    @media screen and (max-width: 800px) {
      display: none;
    }
  }

  .profile {
    @media screen and (max-width: 800px) {
      margin-right: 30px;
      height: 21px;
    }
  }

  .hamburger {
    display: none;
    height: 15px;
    cursor: pointer;

    @media screen and (max-width: 800px) {
      display: block;
    }
  }
}

.slider {
  position: fixed;
  z-index: 999;
  top: 0;
  right: 0;
  height: 100%;
  background: white;
  width: 0;
  transition: width 0.5s;

  &.swipe {
    width: 100%;
  }
}
</style>
